export const QueryKey = {
	GET_SPACEX_LAUNCHES: 'GetSpaceXLaunches',
	GET_PROGRAM_DETAILS: 'GetProgramDetails',
	GET_COACHING_PLAN_DETAILS: 'GetCoachingPlanDetails',
	GET_COACHING_PLAN_DETAILS_PROVIDER: 'GetCoachingPlanDetailsProvider',
	GET_PREV_ASSIGNED: 'GetPreviouslyAssigned',
	GET_HEP_EXERCISE_DETAILS: 'GetHepExerciseDetails',
	GET_PROGRAM_DETAILS_PROVIDER: 'GetProgramDetailsProvider',
	GET_PROVIDER_PROTOCOLS: 'GetProviderProtocols',
	GET_COPY_PROGRAM_DETAILS_PROVIDER: 'GetCopyProgramDetailsProvider',
	GET_COPY_OT_PROGRAM_DETAILS_PROVIDER: 'GetCopyOtProgramDetailsProvider',
	GET_OT_PROGRAM_DETAILS: 'GetOTProgramDetails',
	GET_OT_EXERCISE_DETAILS: 'GetOTExerciseDetails',
	GET_VIRTUAL_MSK_PROGRAM_DETAILS: 'GetVirtualMSKProgramDetails',
	GET_VIRTUAL_MSK_EXERCISE_DETAILS: 'GetVirtualMSKExerciseDetails',
	GET_VIRTUAL_MSK_BUNDLES: 'GetVirtualMSKBundles',
	// #region Fitness Coach
	GET_FC_PROGRAM_DETAILS: 'GetFCProgramDetails',
	// #endregion
};
